// The exception belongs to this URL only. Never restore it from storage or a
// previous route: visiting the public signup URL must always use public policy.
function getVsSignupExceptionKey (route) {
  const match = route.path.match(/^\/special-signup\/([^/]+)\/register(?:\/|$)/i)
  if (!match) return undefined
  try {
    return decodeURIComponent(match[1])
  } catch (_) {
    // Still send malformed keys to the server as supplied. Treating them as
    // absent would incorrectly apply public pre-cutoff availability.
    return match[1]
  }
}

function vsSignupRoute (route, name) {
  const exceptionKey = getVsSignupExceptionKey(route)
  return exceptionKey
    ? { name: `special-${name}`, params: { exceptionKey } }
    : { name }
}

function vsSignupStorageKey (route, key) {
  const exceptionKey = getVsSignupExceptionKey(route)
  return exceptionKey ? `${key}:special:${exceptionKey}` : key
}

// Use server time and elapsed request time, not the customer's wall clock.
// A slow response must not keep an already-closed public signup page open.
function vsSignupRemainingMs (availability, elapsedMs = 0) {
  return Date.parse(availability.cutoffAt) - Date.parse(availability.serverTime) - elapsedMs
}

function isVsSignupAllowed (availability, exceptionKey, elapsedMs = 0) {
  return availability?.allowed === true &&
    Number.isFinite(vsSignupRemainingMs(availability, elapsedMs)) &&
    (!!exceptionKey || vsSignupRemainingMs(availability, elapsedMs) > 0)
}

function isVsSignupClosedError (error) {
  return (error.graphQLErrors || []).some(error =>
    error.message === 'VS_SIGNUP_CLOSED' &&
    (error.code || error.extensions?.code) === 'NOT_FOUND_ERROR'
  )
}

module.exports = {
  getVsSignupExceptionKey,
  vsSignupRoute,
  vsSignupStorageKey,
  vsSignupRemainingMs,
  isVsSignupAllowed,
  isVsSignupClosedError
}
